import axiosHttpRequest from "../axios";

//Live Rakes List
async function getLiveRakesListService(endpoint, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithoutParams(
    endpoint,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

async function getLiveRakeGpsDetailsService(
  endpoint,
  queryparams,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  return listViewData;
}

export default {
  getLiveRakesListService,
  getLiveRakeGpsDetailsService,
};
